import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthGuard } from '../../guards/auth-guard';

@Component({
    selector: 'login',
    template: ''
})

export class Login {
    constructor(private route: ActivatedRoute, public router: Router, private auth: AuthGuard) {
        this.auth.login();
    }
}